export default __webpack_public_path__ + "static/media/slider-img-1.42d7db02.png";